// pairUp takes an array and creates an array of arrays, where the internal
// arrays represent a pairing of each element with the next element from the
// original array
// Example: pairUp([A, B, C, D]) => [[A, B], [B, C], [C, D]]
function pairUp(arr) {
  return arr.reduce((acc, _, i, a) => {
    if (i < a.length - 1) {
      acc.push([a[i], a[i + 1]]);
    }
    return acc;
  }, []);
}
export default pairUp;